/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#000000',
    checkMarkFocusColor: '#016b6a',
    checkMarkHeight: 24,
    checkMarkHoverColor: '#016b6a',
    checkMarkIcon: PaletteIconCheck,
    checkMarkSelectedColor: '#000000',
    checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
    checkMarkWidth: 24,
    padding: 16
  }
}
export default theme
